export const GET_SCHEMAS_SUCCESS = "GET_SCHEMAS_SUCCESS";
export const GET_SCHEMA_SUCCESS  = "GET_SCHEMA_SUCCESS";
export const GET_REQUEST_SUCCESS = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR   = "GET_REQUEST_ERROR";
